import { render, staticRenderFns } from "./RegularTable.vue?vue&type=template&id=d68ac582&scoped=true"
import script from "./RegularTable.vue?vue&type=script&lang=js"
export * from "./RegularTable.vue?vue&type=script&lang=js"
import style0 from "./RegularTable.vue?vue&type=style&index=0&id=d68ac582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68ac582",
  null
  
)

export default component.exports